"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderRefundPromotion = void 0;
const class_validator_1 = require("class-validator");
const errorTypes_1 = require("../../../../apis/spg/helpers/errorTypes");
const SalesOrderRefundItem_1 = require("./SalesOrderRefundItem");
/**
 * A promotion that is being removed in a refund that was on the original order
 */
class SalesOrderRefundPromotion extends SalesOrderRefundItem_1.SalesOrderRefundItem {
    /**
     * The total amount being refunded for promotion which takes into consideration of how many to be removed and the promotion discount price
     */
    get priceRefunded() {
        // price is negative as it is being removed/reversed
        return -parseFloat((this.quantity * this.promotion.priceDiscounted).toFixed(2));
    }
    /**
     * Transforms sales order refund promotions data such that it can be consumed by a comms
     * template
     */
    get commsData() {
        const { promotion: { description }, priceRefunded } = this;
        return {
            description,
            priceRefunded: Math.abs(priceRefunded).toFixed(2)
        };
    }
    serialize() {
        return Object.assign(Object.assign({}, super.serialize()), { promotion: this.promotion });
    }
    static unserialize(data) {
        const newSalesOrderRefundPromotion = new this();
        newSalesOrderRefundPromotion.promotion = data.promotion;
        newSalesOrderRefundPromotion.quantity = data.quantity;
        return newSalesOrderRefundPromotion;
    }
    async validate() {
        const validated = await (0, class_validator_1.validate)(this);
        if (validated.length > 0) {
            throw new errorTypes_1.ValidationError(validated);
        }
        return true;
    }
}
__decorate([
    (0, class_validator_1.IsNotEmpty)()
], SalesOrderRefundPromotion.prototype, "promotion", void 0);
exports.SalesOrderRefundPromotion = SalesOrderRefundPromotion;
//# sourceMappingURL=SalesOrderRefundPromotion.js.map